import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { createElementObject, createLayerComponent, extendContext } from '@react-leaflet/core';
import { LayerGroup as LeafletLayerGroup } from 'leaflet';
export var LayerGroup = createLayerComponent(function createLayerGroup(_ref, ctx) {
  var _c = _ref.children,
      options = _objectWithoutPropertiesLoose(_ref, ["children"]);

  var group = new LeafletLayerGroup([], options);
  return createElementObject(group, extendContext(ctx, {
    layerContainer: group
  }));
});